/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}
const FamilyBaseMachineGroupAvailabilityTable = props => {

    const colDefs = [];

    colDefs.push(
        {
            field: 'itemDesc',
            headerName: 'Item Availability',
            width: 185,
            cellRenderer: params => {

                if ( params.value === 'Total Capacity' ||
                params.value === 'Forecast' ||
                params.value === 'Total Ordered' ) return ( <span>{params.value}</span> );
                return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=F&constraintkey=${params.value}`}>{params.value}</Link> );

            }
        }
    );

    props.lastWeeks.forEach( weekObj => {

        const weekEnding = formatGivenDate( weekObj.weekEnding, 'YYYY-MM-DD' );
        const selectedWeekEnding = formatGivenDate( Number( props.selectedLastWeek ), 'YYYY-MM-DD' );

        if ( weekEnding === selectedWeekEnding ||
            new Date( weekEnding ) < new Date( selectedWeekEnding ) ) {

            const dateVal = weekObj.weekEnding;
            const headerName = `${weekObj.monthNumber} ${formatGivenDate( Number( dateVal ), 'DDMMMYY' )}`.toUpperCase();
            const dateField = formatGivenDate( Number( dateVal ), 'YYYY-MM-DD' );

            if ( dateField !== '2000-01-01' && dateField !== '2000-02-01' ) {

                colDefs.push(
                    {

                        field: `${Number( dateVal )}`,
                        headerName: `${headerName}`,
                        width: 100,
                        cellClassRules: {
                            'atp-family-base-machine-group-availability-result-red-cell': 'x < 0'
                        },
                        cellRenderer: params => {

                            if ( params.value > 99999 ) return ( <span>Infinite</span> );
                            return ( <span>{params.value}</span> );

                        }

                    }
                );

            }

        }

    } );
    return (

        <section className="atp-search-result-panel family-base-machine-group-availability-result-panel ">
            <div className="results-message ">
                {`${props.titleName}`}
            </div>
            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={colDefs}
                    rowData={props.results}
                    onGridReady={onGridReady}
                    headerHeight={56}
                />
            </div>
        </section>
    );

};

FamilyBaseMachineGroupAvailabilityTable.propTypes = {
    results: PropTypes.array.isRequired,
    titleName: PropTypes.string.isRequired,
    selectedLastWeek: PropTypes.string.isRequired,
    lastWeeks: PropTypes.array.isRequired
};
export default FamilyBaseMachineGroupAvailabilityTable;
